import LoginPage from "../pages/guest/login.vue";
import ConfigPage from "../pages/guest/config.vue";
import ProgramInfoPage from "../pages/guest/program-info.vue";
import LicenseInfoPage from "../pages/guest/license-info.vue";
import UserInfoPage from "../pages/all_user/user/user-info.vue";
import RegistPage from "../pages/guest/regist.vue";
import ParentAgreePage from "../pages/guest/parent-agree.vue";
import ParentRegistPage from "../pages/guest/parent-regist.vue";
import SelectRegistPage from "../pages/guest/select-regist.vue";
import IdPwPage from "../pages/guest/idpw.vue";
import InDiInfoPage from "../pages/guest/indi-info.vue";
import UseInfoPage from "../pages/guest/use-info.vue";

import GuestDiagMainPage from "../pages/guest/diag/guest-diag-main.vue";
import GuestPQATMainPage from "../pages/guest/pqat/guest-pqat-main.vue";

import EditStudentPage from "../pages/all_user/user/edit-student.vue";
import EditTeacherPage from "../pages/all_user/user/edit-teacher.vue";

import CLMDashBoardPage from "../pages/campgnrl_leader/manage/cgl-dashboard.vue";
import CLMStudyDetailInfoPage from "../pages/campgnrl_leader/manage/study/cgl-study-detail-info.vue";
import CLMPayDetailInfoPage from "../pages/campgnrl_leader/manage/pay/cgl-pay-detail-info.vue";

import CGMDashBoardPage from "../pages/campgnrl_member/dashboard/cgm-dashboard.vue";
import CGMWeekStudyPage from "../pages/campgnrl_member/week/cgm-week-study.vue";
import CGMWeekDangerPage from "../pages/campgnrl_member/week/cgm-week-danger.vue";
import CGMWeekActivityPage from "../pages/campgnrl_member/week/cgm-week-activity.vue";


import CCMCourseListPage from "../pages/campclass_member/myroom/ccm-course-list.vue";
import CCMCourseDashBoardPage from "../pages/campclass_member/myroom/ccm-course-dashboard.vue";
import CCMMyPointListPage from "../pages/campclass_member/myroom/ccm-my-point-list.vue";
import CCMHomeworkStudyPage from "../pages/campclass_member/myroom/ccm-homework-study.vue";

import CCMCodeStudyPage from "../pages/campclass_member/study/ccm-code-study.vue";
import CCMCodeApplyPage from "../pages/campclass_member/study/ccm-code-apply.vue";
import CCMExamSetApplyPopPage from "../pages/campclass_member/study/sub/ccm-examset-apply.vue";
import CCMMatchPaperApplyPopPage from "../pages/campclass_member/study/sub/ccm-matchpaper-apply.vue";
import CCMMatchBookApplyPopPage from "../pages/campclass_member/study/sub/ccm-matchbook-apply.vue";
import CCMClinicStudyPage from "../pages/campclass_member/study/ccm-clinic-study.vue";
import CCMClinicApplyPage from "../pages/campclass_member/study/sub/ccm-clinic-apply.vue";
import CCMPatConquerStudyPage from "../pages/campclass_member/study/ccm-pat-conquer-study.vue";
import CCMPatConquerApplyPage from "../pages/campclass_member/study/sub/ccm-pat-conquer-apply.vue";
import CCMMatchBookStudyPage from "../pages/campclass_member/study/ccm-matchbook-study.vue";
import CCMMatchBookAddExamPage from "../pages/campclass_member/study/sub/ccm-matchbook-add-exam.vue";
import CCMMatchPaperStudyPage from "../pages/campclass_member/study/ccm-matchpaper-study.vue";
import CCMSmartBookStudyPage from "../pages/campclass_member/study/ccm-smartbook-study.vue";
import CCMSelfStudyPage from "../pages/campclass_member/study/ccm-self-study.vue";
import CCMStudyPlanDayPage  from "../pages/campclass_member/planner/ccm-study-plan-day.vue";
import CCMStudyPlanWeekPage from "../pages/campclass_member/planner/ccm-study-plan-week.vue";
import CCMStudyPlanMonthPage from "../pages/campclass_member/planner/ccm-study-plan-month.vue";
import CCMStudyPlanReviewPage from "../pages/campclass_member/planner/sub/ccm-study-plan-review-apply.vue";
import CCMStudyPlanUnitPage from "../pages/campclass_member/planner/sub/ccm-study-plan-unit-apply.vue";
import CCMStudyPlanClinicPage from "../pages/campclass_member/planner/sub/ccm-study-plan-clinic-apply.vue";

//parent
import CPMPayMentListPage from "../pages/campparent_member/myroom/payment-list.vue";
import CPMPayMentFinalListPage from "../pages/campparent_member/myroom/payment-final-list.vue";
import CPMPayMentResultListPage from "../pages/campparent_member/myroom/payment-result-list.vue";
import CPMPayMentResultViewPage from "../pages/campparent_member/myroom/payment-result-view.vue";
import CPMPayMentOnlineListPage from "../pages/campparent_member/myroom/payment-online-list.vue";
import CPMChildStudyReportPage from "../pages/campparent_member/child/child-study-report.vue";



import NoticeListPage from "../pages/all_user/cs/notice.vue";
import ContentsReportListPage from "../pages/all_user/cs/report_list.vue";
import ContentsReportPopPage from "../pages/all_user/cs/contents_report.vue";

import HomePage from "../pages/home.vue";
import AboutPage from "../pages/about.vue";
import FormPage from "../pages/form.vue";

import LeftPage1 from "../pages/left-page-1.vue";
import LeftPage2 from "../pages/left-page-2.vue";
import DynamicRoutePage from "../pages/dynamic-route.vue";
import RequestAndLoad from "../pages/request-and-load.vue";
import NotFoundPage from "../pages/404.vue";

import AUTH from "./common/auth.js"
import PAGES from "./pages";

import TESTPAGE1 from "../pages/test_layout/test-layout1.vue"; 


function selectMenu(url) {
  var menuItemElements = $(".menu-panel-item");
  var a = menuItemElements.find("a.item-link[href='" + url + "']");
  if (a.length) {
    menuItemElements.removeClass("selected");

    var li = a.closest("li");
    li.addClass("selected");
  }
}

function onBeforeEnterRequireAuth(to, from, resolve, reject) {
  if (AUTH.isGuest()) {
    reject();

    PAGES.login();
  } else {
    selectMenu(to.url);

    return resolve();
  }
}

function onBeforeEnter(to, from, resolve, reject) {
  selectMenu(to.url);

  return resolve();
}

var routes = [
  {
    path: PAGES.LOGIN_PAGE,
    component: LoginPage,
    beforeEnter: onBeforeEnter,
  },
  {
    path: PAGES.REGIST_PAGE,
    component: RegistPage,
    beforeEnter: onBeforeEnter,
  },
  {
    path: PAGES.PARENT_AGREE_PAGE,   
    component: ParentAgreePage,
    beforeEnter: onBeforeEnter,
  },
  {
    path: PAGES.PARENT_REGIST_PAGE,
    component: ParentRegistPage,
    beforeEnter: onBeforeEnter,
  },
  {
    path: PAGES.SELECT_REGIST_PAGE,
    component: SelectRegistPage,
    beforeEnter: onBeforeEnter,
  },
  {
    path: PAGES.EDIT_STUDENT_PAGE + "/:passWord",
    component: EditStudentPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },
  {
    path: PAGES.EDIT_TEACHER_PAGE + "/:passWord",
    component: EditTeacherPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },
  {
    path: PAGES.IDPW_PAGE,
    component: IdPwPage,
    beforeEnter: onBeforeEnter,
  },

  {
    path: PAGES.MENU_GUEST_DIAG_MAIN_PAGE,
    component: GuestDiagMainPage,
    beforeEnter: onBeforeEnter,
  },
  {
    path: PAGES.MENU_GUEST_PQAT_MAIN_PAGE,
    component: GuestPQATMainPage,
    beforeEnter: onBeforeEnter,
  },
  {
    path: PAGES.MAIN_PAGE,
    component: LoginPage,
    beforeEnter: onBeforeEnter,
  },
  {
    path: PAGES.CONFIG_PAGE,
    component: ConfigPage,
    beforeEnter: onBeforeEnter,
  },
  {
    path: PAGES.PROGRAM_INFO_PAGE,
    component: ProgramInfoPage,
    beforeEnter: onBeforeEnter,
  },
  {
    path: PAGES.LICENSE_INFO_PAGE,
    component: LicenseInfoPage,
    beforeEnter: onBeforeEnter,
  },

  {
    path: PAGES.USER_INFO_PAGE,
    component: UserInfoPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },

  {
    path: PAGES.INDI_INFO_PAGE,
    component: InDiInfoPage,
    beforeEnter: onBeforeEnter,
  },

  {
    path: PAGES.USE_INFO_PAGE,
    component: UseInfoPage,
    beforeEnter: onBeforeEnter,
  },

  {
    path: PAGES.MENU_CCM_COURSE_LIST,
    component: CCMCourseListPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },
  {
    path: PAGES.SUB_CCM_COURSE_DASHBOARD,
    component: CCMCourseDashBoardPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },
  {
    path: PAGES.MENU_CCM_CODE_STUDY,
    component: CCMCodeStudyPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },
  {
    path: PAGES.MENU_CCM_CODE_APPLY,
    component: CCMCodeApplyPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },
  {
    path: PAGES.SUB_CCM_EXAMSET_APPLY,
    component: CCMExamSetApplyPopPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },
  {
    path: PAGES.SUB_CCM_MATCHPAPER_APPLY,
    component: CCMMatchPaperApplyPopPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },
  {
    path: PAGES.SUB_CCM_MATCHBOOK_APPLY,
    component: CCMMatchBookApplyPopPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },
  {
    path: PAGES.MENU_CCM_HOMEWORK_LIST,
    component: CCMHomeworkStudyPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },
  {
    path: PAGES.MENU_CCM_CLINIC_STUDY,
    component: CCMClinicStudyPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },
  {
    path: PAGES.SUB_CCM_CLINIC_APPLY,
    component: CCMClinicApplyPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },
  {
    path: PAGES.MENU_CCM_PAT_CONQUER_STUDY,
    component: CCMPatConquerStudyPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },
  {
    path: PAGES.SUB_CCM_PAT_CONQUER_APPLY, // param patKey1 .. patKey3
    component: CCMPatConquerApplyPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },
  {
    path: PAGES.MENU_CCM_MATCHBOOK_STUDY,
    component: CCMMatchBookStudyPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },
  {
    path: PAGES.SUB_CCM_MATCHBOOK_ADD_EXAM,
    component: CCMMatchBookAddExamPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },

  {
    path: PAGES.MENU_CCM_MATCHPAPER_STUDY,
    component: CCMMatchPaperStudyPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },
  {
    path: PAGES.MENU_CCM_SMARTBOOK_STUDY,
    component: CCMSmartBookStudyPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },
  {
    path: PAGES.MENU_CCM_SELF_STUDY,
    component: CCMSelfStudyPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },
  {
    path: PAGES.MENU_CCM_STUDY_PLAN_DAY,
    component: CCMStudyPlanDayPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },
  {
    path: PAGES.MENU_CCM_STUDY_PLAN_WEEK,
    component: CCMStudyPlanWeekPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },
  {
    path: PAGES.MENU_CCM_STUDY_PLAN_MONTH,
    component: CCMStudyPlanMonthPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },
  {
    path: PAGES.SUB_CCM_STUDY_PLAN_REVIEW_APPLY,
    component: CCMStudyPlanReviewPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },
  {
    path: PAGES.SUB_CCM_STUDY_PLAN_UNIT_APPLY,
    component: CCMStudyPlanUnitPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },
  {
    path: PAGES.SUB_CCM_STUDY_PLAN_CLINIC_APPLY,
    component: CCMStudyPlanClinicPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },

  {
    path: PAGES.CGM_DASHBOARD,
    component: CGMDashBoardPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },

  {
    path: PAGES.CGM_WEEKSTUDY,
    component: CGMWeekStudyPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },

  {
    path: PAGES.CGM_WEEKDANGER,
    component: CGMWeekDangerPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },

  {
    path: PAGES.CGM_WEEKACTIVITY,
    component: CGMWeekActivityPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },

  {
    path: PAGES.NOTICE_LIST,
    component: NoticeListPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },

  {
    path: PAGES.MENU_CCM_POINT_LIST,
    component: CCMMyPointListPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },

  {
    path: PAGES.MENU_CONTENTS_REPORT_LIST,
    component: ContentsReportListPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },
  {
    path: PAGES.SUB_CONTENTS_REPORT,
    component: ContentsReportPopPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },

  //parent
  {
    path: PAGES.MENU_PAYMENT_LIST,
    component: CPMPayMentListPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },

  {
    path: PAGES.SUB_PAYMENT_FINAL_LIST,
    component: CPMPayMentFinalListPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },

  {
    path: PAGES.MENU_PAYMENT_RESULT_LIST,
    component: CPMPayMentResultListPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },

  {
    path: PAGES.MENU_PAYMENT_ONLINE_LIST,
    component: CPMPayMentOnlineListPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },

  {
    path: PAGES.MENU_CHILD_STUDY_REPORT,
    component: CPMChildStudyReportPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },

  {
    path: PAGES.SUB_PAYMENT_RESULT_VIEW,
    component: CPMPayMentResultViewPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },

  //원장 
  {
    path: PAGES.MENU_CGL_DASH_BOARD,
    component: CLMDashBoardPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },
  {
    path: PAGES.SUB_CGL_STUDY_DETAIL,
    component: CLMStudyDetailInfoPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },
  {
    path: PAGES.SUB_CGL_PAY_DETAIL,
    component: CLMPayDetailInfoPage,
    beforeEnter: onBeforeEnterRequireAuth,
  },

  //testpage
  {
    path: PAGES.TEST_LAYOUT_PAGE1,
    component: TESTPAGE1,
    beforeEnter: onBeforeEnter,
  },

  {
    path: "/about/",
    component: AboutPage,
  },
  {
    path: "/form/",
    component: FormPage,
  },

  {
    path: "/left-page-1/",
    component: LeftPage1,
  },
  {
    path: "/left-page-2/",
    component: LeftPage2,
  },
  {
    path: "/dynamic-route/blog/:blogId/post/:postId/",
    component: DynamicRoutePage,
  },

  {
    path: "/request-and-load/user/:userId/",
    async: function(routeTo, routeFrom, resolve, reject) {
      // Router instance
      var router = this;

      // App instance
      var app = router.app;

      // Show Preloader
      app.preloader.show();

      // User ID from request
      var userId = routeTo.params.userId;

      // Simulate Ajax Request
      setTimeout(function() {
        // We got user data from request
        var user = {
          firstName: "Vladimir",
          lastName: "Kharlampidi",
          about: "Hello, i am creator of Framework7! Hope you like it!",
          links: [
            {
              title: "Framework7 Website",
              url: "http://framework7.io",
            },
            {
              title: "Framework7 Forum",
              url: "http://forum.framework7.io",
            },
          ],
        };
        // Hide Preloader
        app.preloader.hide();

        // Resolve route to load page
        resolve(
          {
            component: RequestAndLoad,
          },
          {
            context: {
              user: user,
            },
          }
        );
      }, 1000);
    },
  },
  {
    path: "(.*)",
    component: NotFoundPage,
  },
];

export default routes;
